const videos = [
    { id: '1mub-ru8BTo?list=PLQ02IYL5pmhFYDrmxNHAlwgcHOR4h1bPa' },
    { id: '1mub-ru8BTo?list=PLQ02IYL5pmhFYDrmxNHAlwgcHOR4h1bPa' },
    { id: '1mub-ru8BTo?list=PLQ02IYL5pmhFYDrmxNHAlwgcHOR4h1bPa' },
    { id: '1mub-ru8BTo?list=PLQ02IYL5pmhFYDrmxNHAlwgcHOR4h1bPa' },
    { id: '1mub-ru8BTo?list=PLQ02IYL5pmhFYDrmxNHAlwgcHOR4h1bPa' },
    { id: '1mub-ru8BTo?list=PLQ02IYL5pmhFYDrmxNHAlwgcHOR4h1bPa' },
];

export default videos;